const isPDD = /\/products\/[^\/]+$/.test(location.pathname);

window.addEventListener("scroll", function () {
  var element = document.getElementById("site-nav");
  var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollPosition >= 31) {
    element.classList.add("active");
  } else {
    element.classList.remove("active");
  }
});
